{
  "zh-CN": {
    "actions": {
      "admin": {
        "dashboard": {
          "reloadModels": "重新加载模型",
          "reloadScData": "重新加载 SC 数据",
          "reloadPaints": "重新加载涂装",
          "reloadModules": "重新加载模块",
          "reloadLoaners": "重新加载借用船"
        },
        "supporterContributions": {
          "syncFromPatreon": "从 Patreon 同步"
        }
      },
      "duplicate": "复制",
      "showReleased": "显示旧版本",
      "hideReleased": "隐藏旧版本",
      "upgrade": "更新可用！",
      "backToHome": "规划新航线",
      "disableGrouping": "禁用分组",
      "enableGrouping": "启用分组",
      "groupedByModel": "按型号分组",
      "ungrouped": "未分组",
      "destroyAccount": "删除账户",
      "saveScreenshot": "保存为PNG",
      "resolve": "解决",
      "verify": "验证",
      "clearHistory": "清除历史",
      "sortBy": "排序方式",
      "back": "返回",
      "open": "打开",
      "copy": "复制",
      "more": "更多...",
      "showMore": "显示更多",
      "export": "导出",
      "exportHangarLink": "导出到 hangar.link",
      "import": "导入",
      "here": "这里",
      "backToList": "返回列表",
      "backToTop": "返回顶部",
      "previous": "上一个",
      "next": "下一个",
      "cancel": "取消",
      "ok": "确定",
      "reset": "重置",
      "reload": "重新加载",
      "confirm": "确认",
      "moreInfo": "更多信息",
      "showDetailPage": "详情页面",
      "showDetails": "显示详情",
      "hideDetails": "隐藏详情",
      "showGuide": "显示指南",
      "hideGuide": "隐藏指南",
      "showFleetchart": "舰队图表",
      "hideFleetchart": "默认视图",
      "fleetchartApp": {
        "useExtendedState": "以展开状态显示飞船",
        "useRetractedState": "以收起状态显示飞船"
      },
      "showLabels": "显示标签",
      "hideLabels": "隐藏标签",
      "resetZoom": "重置缩放",
      "supportUs": "支持FleetYards.net",
      "supportHint": {
        "cta": "支持 FleetYards",
        "later": "稍后再说"
      },
      "login": "登录",
      "signUp": "注册",
      "confirmAccess": "确认密码",
      "sendConfirmAccessEmail": "发送确认邮件",
      "reset-password": "忘记密码？",
      "edit": "编辑",
      "clear": "清除",
      "done": "完成",
      "share": "分享",
      "change": "更改",
      "upload": "上传",
      "save": "保存",
      "enable": "启用",
      "disable": "禁用",
      "manage": "管理",
      "enableGlobally": "全局启用",
      "disableGlobally": "全局禁用",
      "addActor": "添加角色",
      "addGroup": "添加组",
      "editGroup": "编辑组",
      "remove": "移除",
      "reorder": "重新排序",
      "delete": "删除",
      "deleteSelected": "删除选中项",
      "enableSelected": "启用选中项",
      "disableSelected": "禁用选中项",
      "close": "关闭",
      "filter": "过滤",
      "showStatusColor": "显示状态颜色",
      "hideStatusColor": "隐藏状态颜色",
      "addToHangar": "添加到机库",
      "resetFilter": "重置过滤器",
      "resetPrices": "重置价格",
      "requestPassword": "请求密码邮件",
      "changePassword": "更改密码",
      "updatePassword": "更新密码",
      "copyBackupCodes": "复制备份代码",
      "regenerate": "重新生成",
      "add": "添加",
      "create": "创建",
      "addToWishlist": "添加到愿望清单",
      "addAnother": "添加另一个",
      "addVehicle": "添加飞船",
      "addModule": "添加另一个模块",
      "addUpgrade": "添加另一个升级",
      "showTableView": "显示为列表",
      "showGridView": "显示为网格",
      "linkExisting": "链接现有",
      "loadMore": "加载更多",
      "unlink": "取消链接",
      "syncRsiHangar": "同步RSI机库",
      "oauthApplications": {
        "create": "新建应用",
        "regenerateSecret": "重新生成密钥"
      },
      "oauthAuthorize": {
        "authorize": "授权",
        "deny": "拒绝"
      },
      "verifyWithCitizenId": "使用 Citizen iD 验证",
      "oauth": {
        "signInWith": "通过以下方式登录",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "已连接到 Google",
          "discord": "已连接到 Discord",
          "bluesky": "已连接到 BlueSky",
          "github": "已连接到 GitHub",
          "twitch": "已连接到 Twitch",
          "citizenid": "已连接到 Citizen iD"
        },
        "disconnect": {
          "google": "断开 Google 连接",
          "discord": "断开 Discord 连接",
          "bluesky": "断开 BlueSky 连接",
          "github": "断开 GitHub 连接",
          "twitch": "断开 Twitch 连接",
          "citizenid": "断开 Citizen iD 连接"
        }
      },
      "compare": {
        "ships": "对比"
      },
      "cargoGrids": {
        "addShips": "添加飞船"
      },
      "hangar": {
        "editGroups": "Add or remove Groups",
        "editName": "Name your Ship",
        "manageLoadouts": "管理配置",
        "manageCargo": "管理货物",
        "backToHangar": "返回机库",
        "useName": "Use Name",
        "destroyAll": "Remove all Ships",
        "showOnPublicHangar": "Make Public",
        "hideFromPublicHangar": "Hide from Public",
        "editGroupsSelected": "Add/Remove from Groups",
        "resetIngame": {
          "openModal": "数据重置后重置游戏内飞船",
          "moveToWishlist": "Move to Wishlist",
          "removeAll": "Remove all"
        }
      },
      "syncExtension": {
        "cancel": "取消",
        "start": "Start Sync",
        "retry": "重试同步",
        "close": "关闭",
        "refresh": "刷新页面"
      },
      "empty": {
        "hangarGuide": "Need Help?",
        "reset": "清除筛选"
      },
      "destroyFleet": "解散舰队",
      "restore": "恢复",
      "fleet": {
        "join": "Join %{fleet}!",
        "leave": "Leave %{fleet}",
        "createInviteUrl": "Create Invite Urls",
        "inviteMember": "Invite new Member",
        "manageInvites": "邀请",
        "worldmap": "世界地图",
        "starmap": "星图",
        "membersList": "成员",
        "acceptInvite": "Accept Invitation",
        "declineInvite": "Decline Invitation",
        "acceptRequest": "accept Request",
        "declineRequest": "Decline Request",
        "showOwners": "More",
        "members": {
          "invite": "Invite",
          "promote": "Promote",
          "demote": "Demote",
          "accept": "Accept",
          "decline": "Decline",
          "remove": "移除",
          "editRole": "编辑角色"
        },
        "inviteUrls": {
          "create": "Create new Invite Url"
        },
        "discord": {
          "test": "测试 Discord 连接",
          "installBot": "在您的 Discord 服务器中安装 Fleetyards 机器人"
        },
        "calendarSubscription": {
          "enable": "生成订阅链接",
          "rotate": "更换链接",
          "disable": "停用订阅"
        }
      },
      "model": {
        "gallery": "Gallery",
        "onSale": "On Sale: %{price}",
        "store": "RSI Page"
      },
      "models": {
        "sync": "从 RSI 同步",
        "syncMatrix": "同步矩阵",
        "syncScData": "同步 SC 数据",
        "importPaints": "导入涂装",
        "exchangeStoreImage": "使用 RSI 图片",
        "images": "图片",
        "openTableConfiguration": "打开表格配置"
      },
      "users": {
        "loginAs": "以用户身份登录",
        "resendConfirmation": "重新发送确认",
        "sendPasswordReset": "发送密码重置"
      },
      "unselect": "Unselect all Selected",
      "openPriceModal": "Submit Price",
      "twoFactor": {
        "enable": "Enable Two-factor",
        "disable": "Disable Two-factor",
        "generateBackupCodes": "生成备用码"
      },
      "holoViewer": {
        "autoRotate": {
          "enable": "Enable auto rotate",
          "disable": "Disable auto rotate"
        },
        "zoom": {
          "enable": "Enable zoom",
          "disable": "Disable zoom"
        },
        "color": {
          "enable": "Enable colors",
          "disable": "Disable colors"
        }
      },
      "roadmap": {
        "showRemoved": "Show Removed",
        "hideRemoved": "Hide Removed"
      },
      "logistics": {
        "viewRequests": "View Requests",
        "newRequest": "New Request",
        "createRequest": "Create Request",
        "createInventory": "New Inventory",
        "submit": "Submit",
        "approve": "Approve",
        "reject": "Reject",
        "startWork": "Start Work",
        "fulfill": "Fulfill",
        "cancel": "Cancel",
        "addComment": "Add Comment",
        "deposit": "Deposit",
        "withdraw": "Withdraw",
        "createItem": "Add Item",
        "importCsv": "Import CSV",
        "downloadTemplate": "Download Template",
        "destroyInventory": "Delete Inventory",
        "destroyEntry": "Delete Entry",
        "editStockItem": "Edit Item",
        "destroyStockItem": "Delete Item",
        "editInventory": "Edit Inventory",
        "clearCargo": "清空货物",
        "viewCargoGrid": "查看货物网格"
      },
      "adminNotifications": {
        "unread": "标记为未读",
        "archive": "归档",
        "unarchive": "移回收件箱",
        "readAll": "全部标记为已读",
        "destroyAll": "全部删除",
        "sortOldest": "最早优先",
        "sortNewest": "最新优先",
        "select": "选择通知",
        "readSelected": "将所选标记为已读",
        "unreadSelected": "将所选标记为未读",
        "archiveSelected": "归档所选",
        "unarchiveSelected": "将所选移回收件箱",
        "destroySelected": "删除所选"
      },
      "account": {
        "calendarSubscription": {
          "enable": "生成个人日历链接",
          "rotate": "更换链接",
          "disable": "停用订阅"
        }
      },
      "today": "今天",
      "fleets": {
        "missions": {
          "create": "创建任务",
          "edit": "编辑任务",
          "archive": "归档任务",
          "unarchive": "取消归档",
          "destroy": "永久删除",
          "addTeam": "添加小队",
          "addShip": "添加飞船",
          "addSlot": "添加席位",
          "viewMissions": "查看任务"
        },
        "events": {
          "create": "创建活动",
          "edit": "编辑活动",
          "spawn": "从此任务创建",
          "archive": "归档活动",
          "unarchive": "从归档中恢复",
          "syncToDiscord": "同步到 Discord",
          "destroy": "永久删除",
          "publish": "发布",
          "lockSignups": "锁定报名",
          "unlockSignups": "解锁报名",
          "start": "开始",
          "complete": "完成",
          "cancel": "取消",
          "signup": "报名",
          "withdraw": "取消报名",
          "kick": "移除报名",
          "viewEvents": "查看活动",
          "viewCalendar": "查看日历",
          "exportIcs": "导出 iCal",
          "addToCalendar": "添加到日历",
          "subscribe": "订阅",
          "setUpCalendar": "设置日历订阅",
          "assignSlot": "分配到席位",
          "reassignSlot": "移动到其他席位",
          "addSeats": "添加座位",
          "manageEventTeam": "管理活动团队",
          "grantRole": "授予角色",
          "revokeRole": "撤销",
          "editSchedule": "编辑小队与飞船",
          "doneEditing": "完成编辑",
          "addTeam": "添加小队"
        }
      },
      "notifications": {
        "unread": "标记为未读",
        "archive": "归档",
        "unarchive": "移回收件箱",
        "readAll": "全部标记为已读",
        "destroyAll": "全部删除",
        "settings": "通知设置",
        "sortOldest": "最早优先",
        "sortNewest": "最新优先",
        "openCenter": "通知",
        "select": "选择通知",
        "readSelected": "将所选标记为已读",
        "unreadSelected": "将所选标记为未读",
        "archiveSelected": "归档所选",
        "unarchiveSelected": "将所选移回收件箱",
        "destroySelected": "删除所选"
      },
      "unlistedModel": {
        "createModel": "创建飞船",
        "markAsPaint": "这是涂装",
        "ignore": "忽略",
        "noManufacturer": "此标识符无法解析出制造商",
        "alreadyExists": "%{name} 已在目录中",
        "link": "已在目录中",
        "markAsPaintSelected": "将所选标记为涂装",
        "ignoreSelected": "忽略所选"
      },
      "revert": "还原",
      "exportCsv": "导出 CSV",
      "exportAllCsv": "全部导出为 CSV"
    }
  }
}
